  const cards = document.querySelectorAll('.flip-card');
  cards.forEach((card) => {
    card.addEventListener('click', function () {
      // If this card is already flipped, just unflip it
      if (this.classList.contains('flipped')) {
        this.classList.remove('flipped');
      } else {
        // Remove flipped class from all cards
        cards.forEach((c) => c.classList.remove('flipped'));
        // Add flipped class to clicked card
        this.classList.add('flipped');
      }
    });
  });
